"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _react = _interopRequireDefault(require("react"));
var _text = require("@mmc/text");
var _clsx2 = _interopRequireDefault(require("clsx"));
var _input = _interopRequireDefault(require("./input.css"));
var InputPaymentCalculator = exports["default"] = /*#__PURE__*/function (_React$PureComponent) {
  function InputPaymentCalculator(props) {
    var _this;
    _this = _React$PureComponent.call(this, props) || this;
    _this.state = {
      value: props.defaultValue,
      isShowError: false
    };
    _this.handleChange = _this.handleChange.bind(_this);
    _this.updateData = _this.updateData.bind(_this);
    return _this;
  }
  (0, _inheritsLoose2["default"])(InputPaymentCalculator, _React$PureComponent);
  InputPaymentCalculator.getDerivedStateFromProps = function getDerivedStateFromProps(currProps, prevState) {
    if (currProps.resetDefaultValue) {
      return {
        value: undefined
      };
    }
    if (prevState.value === undefined) {
      return {
        value: currProps.defaultValue
      };
    }
    return null;
  };
  var _proto = InputPaymentCalculator.prototype;
  _proto.handleClick = function handleClick(e) {
    e.target.select();
  };
  _proto.handleChange = function handleChange(e) {
    var _this$props = this.props,
      pattern = _this$props.pattern,
      name = _this$props.name,
      minVal = _this$props.minVal,
      maxVal = _this$props.maxVal;
    var value = e.target.value;
    var newVal = value;
    if (minVal && newVal < Number(minVal)) {
      newVal = minVal;
    } else if (maxVal && newVal > Number(maxVal)) {
      newVal = maxVal;
    }
    newVal = newVal.replace(/[^0-9.]/g, '');
    var isValid = !(0, _isEmpty2["default"])(newVal) && new RegExp(pattern).test(newVal);
    var data = {
      value: newVal,
      isShowError: !isValid,
      name: name
    };
    this.updateData(data);
  };
  _proto.updateData = function updateData(data) {
    var onChange = this.props.onChange;
    this.setState(data);
    onChange(data);
  };
  _proto.render = function render() {
    var _clsx;
    var _this$props2 = this.props,
      id = _this$props2.id,
      testID = _this$props2['data-testid'],
      label = _this$props2.label,
      className = _this$props2.className,
      inputClassName = _this$props2.inputClassName,
      errorMessage = _this$props2.errorMessage,
      name = _this$props2.name,
      theme = _this$props2.theme,
      disclaimerNo = _this$props2.disclaimerNo,
      interestRateDisclaimerId = _this$props2.interestRateDisclaimerId,
      disclaimerData = _this$props2.disclaimerData;
    var _this$state = this.state,
      isShowError = _this$state.isShowError,
      value = _this$state.value;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx2["default"])(_input["default"].inputContainer, className)
    }, /*#__PURE__*/_react["default"].createElement("label", {
      htmlFor: id,
      className: (0, _clsx2["default"])(_input["default"].label, (_clsx = {}, _clsx[_input["default"].labelFocused] = value !== null, _clsx))
    }, label, label && disclaimerNo && /*#__PURE__*/_react["default"].createElement("sup", null, disclaimerNo), interestRateDisclaimerId && /*#__PURE__*/_react["default"].createElement(_text.Text, {
      text: "#" + interestRateDisclaimerId + "#",
      disclaimerData: disclaimerData,
      tag: "span",
      className: _input["default"].disclaimer + " " + _input["default"].smallDisclaimer + " " + _input["default"].darkGreyDisclaimer
    })), /*#__PURE__*/_react["default"].createElement("input", {
      "data-testid": testID,
      id: id,
      className: (0, _clsx2["default"])(_input["default"].input, isShowError && _input["default"].inputError, inputClassName),
      name: name,
      onChange: this.handleChange,
      onClick: this.handleClick,
      value: value && typeof value === 'string' && value.includes('null') ? value.replace('null', '0') : value
    }), isShowError && errorMessage && /*#__PURE__*/_react["default"].createElement("p", {
      className: _input["default"].errorMessage
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: (0, _clsx2["default"])(theme.mmcIconFormError, _input["default"].errorMessageIcon)
    }), ' ', errorMessage));
  };
  return InputPaymentCalculator;
}(_react["default"].PureComponent);
InputPaymentCalculator.defaultProps = {
  onChange: function onChange() {
    return undefined;
  }
};